import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      loadPath: 'translations/{{lng}}/{{ns}}.json',
    },
    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    debug: false,
    react: {
      wait: true,
    },
  });

export default i18n;
